/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// HomeFr.js
import React from 'react';
import IntroBlock from './components/IntroBlock';
import NavButton from './components/NavButton';
import LanguageSwitcher from './components/LanguageSwitcher';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';

import BackgroundImage from './components/BackgroundImage';

import ModalFR from './components/ModalFR';

import './App.css';

export default function HomeFr( { onSwitchLanguage }) {

    const [showModal, setShowModal] = React.useState({invest: false, atouts: false, vivre: false, loisirs: false, initiative: false});

    const closeModal = () => {
        setShowModal({invest: false, atouts: false, vivre: false, loisirs: false, initiative: false});
    }

    const openModal = (id) => {
        setShowModal(prev => ({ ...prev, [id]: true }));
    }
    

    return (
            <div className="homepage">
            
                <div className="top-bar">
                    <LanguageSwitcher currentLang="fr" onSwitch={onSwitchLanguage} />
                </div>
            
                <BackgroundImage/>
            
                <IntroBlock lang="fr" onOpenModal={() => openModal('initiative')} />
            
            
                <div className="fixed-bottom-footer">
                    <Container fluid="xs">
                        <div className="footer-content">
                            <p>&copy; {new Date().getFullYear()} The Land Of Innovation</p>
                            <p className="credits">Crédits photo : Pixabay et sous licence.</p>
                        </div>
                    </Container>
                </div>
            
            
                <NavButton label="Vivre ici" position="top-left" onClick={() => openModal('vivre')} />
                <NavButton label="Loisirs" position="top-right" onClick={() => openModal('loisirs')} />
                <NavButton label="Atouts" position="bottom-left" onClick={() => openModal('atouts')}/>
                <NavButton label="Espace Investisseurs" position="bottom-right" onClick={() => openModal('invest')}/>
            
            <ModalFR showModal={showModal} handleClose={closeModal} />
            
            </div>
            );
}
